<template>
    <v-btn :small="isSmall" :class="ml_class" icon @click="changeLanguage();">
        <v-img max-width=25 max-height=20 v-if="$i18n.locale=='zh'" src="../assets/jp_flag.jpg">            
        </v-img>
        <v-img max-width=25 max-height=20 v-else src="../assets/zh_flag.jpg">
        </v-img>
    </v-btn>
</template>
<script>

import i18n from '@/i18n';

export default {
    name: 'SwitchLanguage',
    methods: {
        changeLanguage: function(){
            if(i18n.locale=='zh'){
                i18n.locale='ja';
            }else{
                i18n.locale='zh';
            }
        }
    },
    computed: {
        ml_class: function(){
            if(this.$vuetify.breakpoint.xs){
                return "";
            }
            return "ml-2";
        },
        isSmall: function(){
            return !this.$vuetify.breakpoint.xs;
        }
    }
}
</script>